<!-- Modern MARC Holding Button -->
<button type="button" class="btn btn-light btn-light-walai border rounded-pill py-2" data-bs-toggle="modal"
  data-bs-target="#MARCHoldingModal">
  <i class="bi bi-file-earmark-ruled me-2"></i>
  <span>{{'MARC Holding Record' | translate}}</span>
</button>

<!-- Modern MARC Holding Modal -->
<div class="modal fade" id="MARCHoldingModal" tabindex="-1" aria-labelledby="marcHoldingModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-fullscreen-md-down modal-xl modal-dialog-scrollable">
    <div class="modal-content border-0 shadow-lg">

      <!-- Modal Header -->
      <div class="modal-header bg-light border-0 py-3">
        <div class="d-flex align-items-center gap-3">
          <div class="marc-icon-wrapper">
            <i class="bi bi-file-earmark-ruled text-primary fs-4"></i>
          </div>
          <div>
            <h5 class="modal-title fw-bold mb-0" id="marcHoldingModalLabel">{{ 'MARCHoldingRecord' | translate }}</h5>
            <p class="text-muted small mb-0">{{ 'MARCHolding' | translate }}</p>
          </div>
        </div>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body p-0">
        <div class="marc-container">

          <!-- Holdings Loop -->
          <div *ngFor="let h of holdings; let holdingIndex = index" class="holding-section">

            <!-- Location Header (Collapsible) -->
            <div class="location-header" [attr.data-bs-toggle]="'collapse'"
              [attr.data-bs-target]="'#holdingLocation' + holdingIndex" [attr.aria-expanded]="true"
              [attr.aria-controls]="'holdingLocation' + holdingIndex" style="cursor: pointer;">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center gap-3">
                  <i class="bi bi-geo-alt-fill text-primary"></i>
                  <h5 class="mb-0 text-primary fw-bold">{{ h.locationnamethai }}</h5>
                  <span class="badge bg-primary rounded-pill">{{ h.marcs.length }} {{ 'Records' | translate }}</span>
                </div>
                <i class="bi bi-chevron-down collapse-icon"></i>
              </div>
            </div>

            <!-- MARC Table View for this location -->
            <div class="collapse show marc-table-view" [attr.id]="'holdingLocation' + holdingIndex">
              <!-- Table Header -->
              <div class="marc-header">
                <div class="col-tag">{{ 'Tag' | translate }}</div>
                <div class="col-ind">{{ 'Ind1' | translate }}</div>
                <div class="col-ind">{{ 'Ind2' | translate }}</div>
                <div class="col-data">{{ 'SubfieldData' | translate }}</div>
              </div>

              <!-- Table Body -->
              <div class="marc-body">
                <div *ngFor="let tag of h.marcs; let i = index" class="marc-row" [class.marc-row-even]="i % 2 === 0">
                  <!-- Tag ID -->
                  <div class="col-tag">{{ tag.TagID }}</div>

                  <!-- Indicators -->
                  <ng-container *ngIf="tag.TagID !== 'Leader'; else noInd">
                    <div class="col-ind" [attr.data-label]="'Ind1' | translate">{{ tag.Indicator1 &&
                      tag.Indicator1.trim() !== '' ? tag.Indicator1 : '#' }}</div>
                    <div class="col-ind" [attr.data-label]="'Ind2' | translate">{{ tag.Indicator2 &&
                      tag.Indicator2.trim() !== '' ? tag.Indicator2 : '#' }}</div>
                  </ng-container>
                  <ng-template #noInd>
                    <div class="col-ind"></div>
                    <div class="col-ind"></div>
                  </ng-template>

                  <!-- Subfield Data -->
                  <div class="col-data" [innerHTML]="tag.Subfield"></div>
                </div>
              </div>
            </div>

          </div>

          <!-- Empty State -->
          <div *ngIf="!holdings || holdings.length === 0" class="marc-empty-state">
            <i class="bi bi-inbox fs-1 text-muted mb-3"></i>
            <p class="text-muted">{{ 'NoMARCHoldingRecordsAvailable' | translate }}</p>
          </div>

        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer bg-light border-0">
        <button type="button" class="btn btn-outline-secondary rounded-pill px-4" data-bs-dismiss="modal">
          <i class="bi bi-x-circle me-2"></i>
          {{ 'Close' | translate }}
        </button>
        <button type="button" class="btn btn-primary rounded-pill px-4" (click)="copyToClipboard()">
          <i class="bi bi-clipboard me-2"></i>
          {{ 'CopyMARCHolding' | translate }}
        </button>
      </div>

    </div>
  </div>
</div>